'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { getSuiteProductConfigurations } from 'pricing-pages-lib/utils/productConfigUtils';
import { getProductForSkuId } from 'pricing-pages-lib/utils/productsUtils';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { crmSuiteProductLevelSelector } from '../../selectors/ProductsSelectors';
import { gatesSelector, productDataSelector } from '../../selectors/SelectorUtils';
import { PlanBuilderContext } from './PlanBuilder';
import PlanPickerHeader from './PlanPickerHeader';
import SuiteProductLevelPicker from './SuiteProductLevelPicker';
import SuiteQuantityPackPickers from './SuiteQuantityPackPickers';

const SuitePlanPicker = () => {
  const {
    productConfigurations,
    setProductConfigurations,
    trackingSource,
    setSuiteProductLevel
  } = useContext(PlanBuilderContext);
  const skuIds = productConfigurations.map(({
    skuId
  }) => skuId);
  const selectedProductLevel = useSelector(state => crmSuiteProductLevelSelector(state, {
    skuIds
  }));
  const currencyCode = useSelector(activeCurrencySelector);
  const productData = useSelector(productDataSelector);
  const gates = useSelector(gatesSelector);

  const setProductLevel = newProductLevel => {
    if (newProductLevel !== selectedProductLevel) {
      getUsageTracker().track('clickMerchSelectionButton', {
        currency: currencyCode,
        productName: `suite-${newProductLevel.toLowerCase()}`,
        trackingSource
      });
      setProductConfigurations(oldProductConfigurations => oldProductConfigurations.filter(({
        skuId
      }) => {
        const {
          productLine,
          productLevel
        } = getProductForSkuId({
          productData
        }, {
          skuId
        });
        return !productLine || !productLevel;
      }).concat(getSuiteProductConfigurations({
        productData,
        gates
      }, {
        productLevel: newProductLevel
      })));
      setSuiteProductLevel(newProductLevel);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(PlanPickerHeader, {
      productLine: "crmSuite",
      compact: true,
      trackingSource: trackingSource
    }), /*#__PURE__*/_jsx(SuiteProductLevelPicker, {
      setProductLevel: setProductLevel,
      selectedProductLevel: selectedProductLevel
    }), /*#__PURE__*/_jsx(SuiteQuantityPackPickers, {
      setProductLevel: setProductLevel
    })]
  });
};

export default SuitePlanPicker;